module.exports = __webpack_public_path__ + "resources/img/img_datahunt6_jp.6a3d29a95700924229c460814301cfe5.png";